/**
 * CardListCustom — escape hatch do ListView para cards totalmente custom.
 *
 * Usado quando a página passa renderCard ao ListView. Cada row é
 * renderizada por renderCard(row, index); o wrapper só cuida do
 * empilhamento + clique/teclado acessível.
 */
import React from "react";
import { CardListRoot, Card } from "./styles";

export default function CardListCustom({
  data,
  rowKey,
  onRowClick,
  renderCard,
}) {
  return (
    <CardListRoot>
      {data.map((row, index) => (
        <Card
          key={rowKey(row, index)}
          $clickable={Boolean(onRowClick)}
          onClick={onRowClick ? () => onRowClick(row) : undefined}
          role={onRowClick ? "button" : undefined}
          tabIndex={onRowClick ? 0 : undefined}
          onKeyDown={
            onRowClick
              ? (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onRowClick(row);
                  }
                }
              : undefined
          }
        >
          {renderCard(row, index)}
        </Card>
      ))}
    </CardListRoot>
  );
}
